<template>
  <MyOrdersCard footer-class="pb-100" :to="`/my-orders/keno/${orderId}`">
    <template #header>
      <LcLotteryLogo
        :licensed-territory="getLicensedTerritoryByGameId(gameId)"
        :lottery-id="gameId"
      />
    </template>

    <template #header-end>
      <slot name="header" />
    </template>

    <template #list>
      <IconListItemId :id="orderId" />

      <MyOrdersListItemGame v-bind="{ addOns, spots, wager }" :lottery-id="gameId" />

      <MyOrdersListItemGamesTotal v-bind="{ totalDraws }" />
    </template>

    <template #replay-button>
      <MyOrdersReplayButton
        v-if="isReplayable"
        v-bind="{ gameId }"
        class="py-none px-400"
        :play-slip-order-id="orderId"
        size="small"
        @click.stop.prevent
      />
    </template>

    <template #cta>
      {{ $t('myorders.card.highfrequency.cta') }}
    </template>
  </MyOrdersCard>
</template>

<script lang="ts" setup>
import type {
  HighFrequency_GameId,
  HighFrequency_Order,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

type MyOrdersHighFrequencyCardProps = {
  addOns: HighFrequency_Order['addOns']
  gameId: HighFrequency_Order['gameId']
  orderId: HighFrequency_Order['orderId']
  readyDraws: HighFrequency_Order['readyDraws']
  replayable: HighFrequency_Order['replayable']
  spots: HighFrequency_Order['spots']
  totalDraws: HighFrequency_Order['totalDraws']
  wager: HighFrequency_Order['wager']
}

const props = defineProps<MyOrdersHighFrequencyCardProps>()

const activeLicensedTerritory = useLicensedTerritory({ raw: true })

const getLicensedTerritoryByGameId = (gameId: HighFrequency_GameId) =>
  licensedTerritoryForGameId(gameId) ?? activeLicensedTerritory

const isReplayable = computed(() => canReplayHighFrequencyOrder(props, activeLicensedTerritory))
</script>
